import React from "react";
import PropTypes from "prop-types";
import Step from "../../../../atoms/Wizard/Step";
import MainInput from "../../../../atoms/Forms/MainInput";
import MainTextArea from "../../../../atoms/Forms/MainTextArea";
import MainButtonInput from "../../../../atoms/Forms/MainButtonInput";

import styles from "./MainApp.organisms.Product.ProductSigleLoadWizard.ProductStep1.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";
export class ProdStepOne extends React.Component {
  render() {
    const { product, handleChange, selectCategory, removeCategory, errors } = this.props;

    const stepContent = (
      <div className={styles["product-step-one-content"]}>
        <div className={styles["prod-step-one-field"]} data-automation-id="input-name">
          <MainInput
            label={i18n.t("product.name")}
            required={true}
            id={"product-name"}
            name="name"
            value={product.name}
            handleChange={handleChange}
            maxLength={100}
            error={errors.name}
          />
        </div>
        <div className={styles["prod-step-one-field"]} data-automation-id="input-brand">
          <MainInput
            label={capitalize(i18n.t("brand"))}
            required={true}
            id={"product-brand"}
            name="brand"
            value={product.brand}
            handleChange={handleChange}
            maxLength={50}
            error={errors.brand}
          />
        </div>
        <div
          className={styles["prod-step-one-field"]}
          data-automation-id="input-description"
        >
          <MainTextArea
            label={capitalize(i18n.t("description"))}
            id={"product-description"}
            name="description"
            value={product.description}
            handleChange={handleChange}
            error={errors.description}
          />
        </div>
        <div
          className={styles["prod-step-one-field"]}
          data-automation-id="input-category"
        >
          <MainButtonInput
            label={capitalize(i18n.t("category"))}
            id={"product-category"}
            value={product.category ? product.category.name : null}
            handleClick={selectCategory}
            error={errors.category}
          />

          {product.category && (
            <span className={styles["remove-product-category"]} onClick={removeCategory}>{i18n.t("delete.category")}</span>
          )}
        </div>
      </div>
    );

    return (
      <div className={styles["product-step-one-container"]}>
        <Step title={i18n.t("enter.data")} content={stepContent} paddingVariant="product-padding"></Step>
      </div>
    );
  }
}

ProdStepOne.propTypes = {
  handleChange: PropTypes.func
};

export default ProdStepOne;
